import { useEffect, useState } from "react";
import useAxios from "../../../../../../../hooks/useAxios";
import { CLIENT_PLATFORMS_SELECTABLE } from "../../../../../../../shared/lib/apiEndpointsResolver";
import DialogFormPanel from "../../../../../../../shared/components/panel/DialogFormPanel";
import CreatePlatformClientMappingForm from "./CreatePlatformClientMappingForm";
import CreateButtonTrigger from "../../../../../../../shared/components/button/CreateButtonTrigger";
import { catchFunction } from "../../../../../../../shared/lib/utils";

const CreatePlatformClientMappingDialog = ({ id, onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [platforms, setPlatforms] = useState([]);
  const axios = useAxios();

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  useEffect(() => {
    axios
      .get(CLIENT_PLATFORMS_SELECTABLE(id))
      .then((response) => setPlatforms(response.data))
      .catch(catchFunction);
  }, [id]);

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="clients.detail.tabs.platformMappings.createForm.title"
      description="clients.detail.tabs.platformMappings.createForm.description"
      content={
        <CreatePlatformClientMappingForm
          platforms={platforms}
          onSubmitHandler={onSubmit}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreatePlatformClientMappingDialog;
